$(function () {

	// 熨斗・ラッピングの設定画面がヘッダーとフッターの下に入ってしまうため調整
	$('body').on('click', '#dd-gift .buttons button', function() {
		$('.section-header-tk').css('z-index', '-1');
		$('.section-footer-tk').css('z-index', '-1');
	});

	// 自作のボタンをクリックすると、熨斗・ラッピングの設定画面を開くボタンを疑似クリックさせる
	$('.cart-giftWrapping button').click(function() {
		$('#dd-gift .buttons button').click();
		return false;
	});
});